"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _a, _b;
var Common1 = _createEmoji("1f60a", ":) :-)");
var common2 = _createEmoji("1f609", ";) ;-)");
var common3 = _createEmoji("02764", "<3");
var common4 = _createEmoji("1f61e", ":( :-(");
var common5 = _createEmoji("1f603", ":D :-D");
exports.MoreEmoji = {
    key: "more",
    description: "emjDMore",
    codePoint: ""
};
exports.CommonEmojis = [Common1, common2, common3, common4, common5, exports.MoreEmoji];
var EmojiFamilyKeys;
(function (EmojiFamilyKeys) {
    EmojiFamilyKeys["People"] = "People";
    EmojiFamilyKeys["Nature"] = "Nature";
    EmojiFamilyKeys["Activities"] = "Activities";
    EmojiFamilyKeys["Food"] = "Food";
    EmojiFamilyKeys["Travel"] = "Travel";
    EmojiFamilyKeys["Symbols"] = "Symbols";
    EmojiFamilyKeys["Objects"] = "Objects";
})(EmojiFamilyKeys = exports.EmojiFamilyKeys || (exports.EmojiFamilyKeys = {}));
// NOTE: name for an emoji should be in lower case
var EmojiList = (_a = {},
    _a["People" /* People */] = [
        _createEmoji("1f601"),
        _createEmoji("1f602"),
        common5,
        _createEmoji("1f604"),
        _createEmoji("1f605"),
        _createEmoji("1f606"),
        _createEmoji("1f607"),
        common2,
        Common1,
        _createEmoji("1f642"),
        _createEmoji("1f60b"),
        _createEmoji("1f60c"),
        _createEmoji("1f60d"),
        _createEmoji("1f618"),
        _createEmoji("1f61a"),
        _createEmoji("1f61c"),
        _createEmoji("1f61d", ":p :P :-p :-P"),
        _createEmoji("1f60e", "B) B-)"),
        _createEmoji("1f60f"),
        _createEmoji("1f636"),
        _createEmoji("1f610", ":| :-|"),
        _createEmoji("1f612"),
        _createEmoji("1f633"),
        common4,
        _createEmoji("1f620"),
        _createEmoji("1f621"),
        _createEmoji("1f614"),
        _createEmoji("1f623"),
        _createEmoji("1f616"),
        _createEmoji("1f62b"),
        _createEmoji("1f629"),
        _createEmoji("1f624"),
        _createEmoji("1f631"),
        _createEmoji("1f628"),
        _createEmoji("1f630"),
        _createEmoji("1f625"),
        _createEmoji("1f622"),
        _createEmoji("1f62a"),
        _createEmoji("1f613"),
        _createEmoji("1f62d"),
        _createEmoji("1f635"),
        _createEmoji("1f632", ":o :O :-o :-O"),
        _createEmoji("1f637"),
        _createEmoji("1f4a4"),
        _createEmojiWithNoKeyword("1f608"),
        _createEmoji("1f47f"),
        _createEmojiWithNoKeyword("1f479"),
        _createEmojiWithNoKeyword("1f47a"),
        _createEmoji("1f480"),
        _createEmoji("1f47b"),
        _createEmoji("1f47d"),
        _createEmoji("1f63a"),
        _createEmoji("1f638"),
        _createEmoji("1f639"),
        _createEmoji("1f63b"),
        _createEmoji("1f63c"),
        _createEmoji("1f63d"),
        _createEmojiWithNoKeyword("1f640"),
        _createEmoji("1f63f"),
        _createEmoji("1f63e"),
        _createEmoji("1f64c"),
        _createEmoji("1f44f"),
        _createEmoji("1f44b"),
        _createEmoji("1f44d"),
        _createEmoji("1f44e"),
        _createEmoji("1f44a"),
        _createEmoji("0270a"),
        _createEmoji("0270b"),
        _createEmoji("0270c"),
        _createEmoji("1f44c"),
        _createEmojiWithNoKeyword("1f450"),
        _createEmojiWithNoKeyword("1f596"),
        _createEmoji("1f4aa"),
        _createEmoji("1f64f"),
        _createEmoji("1f446"),
        _createEmoji("1f447"),
        _createEmoji("1f448"),
        _createEmoji("1f449"),
        _createEmoji("1f485"),
        _createEmoji("1f444"),
        _createEmoji("1f445"),
        _createEmoji("1f442"),
        _createEmoji("1f443"),
        _createEmoji("1f440"),
        _createEmojiWithNoKeyword("1f464"),
        _createEmoji("1f476"),
        _createEmoji("1f466"),
        _createEmoji("1f467"),
        _createEmoji("1f468"),
        _createEmoji("1f469"),
        _createEmoji("1f471"),
        _createEmoji("1f474"),
        _createEmoji("1f475"),
        _createEmojiWithNoKeyword("1f472"),
        _createEmojiWithNoKeyword("1f473"),
        _createEmoji("1f46e"),
        _createEmoji("1f477"),
        _createEmoji("1f482"),
        _createEmoji("1f385"),
        _createEmoji("1f47c"),
        _createEmoji("1f478"),
        _createEmoji("1f470"),
        _createEmoji("1f6b6"),
        _createEmoji("1f3c3"),
        _createEmoji("1f483"),
        _createEmoji("1f46f"),
        _createEmoji("1f46b"),
        _createEmojiWithNoKeyword("1f647"),
        _createEmoji("1f481"),
        _createEmoji("1f645"),
        _createEmoji("1f646"),
        _createEmoji("1f64b"),
        _createEmoji("1f64e"),
        _createEmoji("1f64d"),
        _createEmoji("1f487"),
        _createEmoji("1f486"),
        _createEmoji("1f491"),
        _createEmoji("1f48f"),
        _createEmoji("1f46a"),
        _createEmoji("1f45a"),
        _createEmoji("1f455"),
        _createEmoji("1f456"),
        _createEmoji("1f454"),
        _createEmoji("1f457"),
        _createEmoji("1f459"),
        _createEmoji("1f458"),
        _createEmoji("1f484"),
        _createEmoji("1f48b"),
        _createEmoji("1f463"),
        _createEmojiWithNoKeyword("1f460"),
        _createEmoji("1f461"),
        _createEmoji("1f462"),
        _createEmoji("1f45e"),
        _createEmoji("1f45f"),
        _createEmoji("1f452"),
        _createEmoji("1f3a9"),
        _createEmoji("1f393"),
        _createEmoji("1f451"),
        _createEmoji("1f392"),
        _createEmoji("1f45d"),
        _createEmoji("1f45b"),
        _createEmoji("1f45c"),
        _createEmoji("1f4bc"),
        _createEmoji("1f453"),
        _createEmoji("1f48d"),
        _createEmoji("1f302")
    ],
    _a["Nature" /* Nature */] = [
        _createEmoji("1f436"),
        _createEmoji("1f431"),
        _createEmoji("1f42d"),
        _createEmoji("1f439"),
        _createEmoji("1f430"),
        _createEmoji("1f43b"),
        _createEmoji("1f43c"),
        _createEmojiWithNoKeyword("1f428"),
        _createEmoji("1f42f"),
        _createEmoji("1f42e"),
        _createEmoji("1f437"),
        _createEmoji("1f43d"),
        _createEmoji("1f438"),
        _createEmoji("1f419"),
        _createEmoji("1f435"),
        _createEmoji("1f648"),
        _createEmoji("1f649"),
        _createEmoji("1f64a"),
        _createEmoji("1f412"),
        _createEmoji("1f427"),
        _createEmoji("1f426"),
        _createEmojiWithNoKeyword("1f424"),
        _createEmoji("1f423"),
        _createEmoji("1f425"),
        _createEmoji("1f43a"),
        _createEmoji("1f417"),
        _createEmoji("1f434"),
        _createEmoji("1f41d"),
        _createEmoji("1f41b"),
        _createEmoji("1f40c"),
        _createEmoji("1f41e"),
        _createEmoji("1f41c"),
        _createEmoji("1f40d"),
        _createEmoji("1f422"),
        _createEmoji("1f420"),
        _createEmoji("1f41f"),
        _createEmoji("1f421"),
        _createEmoji("1f42c"),
        _createEmoji("1f433"),
        _createEmoji("1f414"),
        _createEmoji("1f42b"),
        _createEmoji("1f418"),
        _createEmoji("1f411"),
        _createEmoji("1f40e"),
        _createEmoji("1f429"),
        _createEmoji("1f43e"),
        _createEmoji("1f432"),
        _createEmoji("1f335"),
        _createEmoji("1f384"),
        _createEmoji("1f334"),
        _createEmoji("1f331"),
        _createEmoji("1f33f"),
        _createEmoji("1f340"),
        _createEmojiWithNoKeyword("1f38d"),
        _createEmojiWithNoKeyword("1f38b"),
        _createEmoji("1f343"),
        _createEmoji("1f342"),
        _createEmoji("1f341"),
        _createEmoji("1f33e"),
        _createEmoji("1f33a"),
        _createEmoji("1f33b"),
        _createEmoji("1f339"),
        _createEmoji("1f33c"),
        _createEmoji("1f337"),
        _createEmoji("1f338"),
        _createEmoji("1f344"),
        _createEmoji("1f490"),
        _createEmoji("1f330"),
        _createEmoji("1f383"),
        _createEmoji("1f41a"),
        _createEmojiWithNoKeyword("1f30f"),
        _createEmoji("1f315"),
        _createEmoji("1f311"),
        _createEmoji("1f313"),
        _createEmoji("1f314"),
        _createEmoji("1f31b"),
        _createEmoji("1f319"),
        _createEmoji("02b50"),
        _createEmoji("1f31f"),
        _createEmojiWithNoKeyword("1f4ab"),
        _createEmoji("02728"),
        _createEmojiWithNoKeyword("02600"),
        _createEmojiWithNoKeyword("026c5"),
        _createEmoji("02601"),
        _createEmoji("026a1"),
        _createEmoji("1f525"),
        _createEmoji("1f4a5"),
        _createEmoji("02744"),
        _createEmoji("026c4"),
        _createEmoji("1f4a8"),
        _createEmoji("02614"),
        _createEmojiWithNoKeyword("1f4a7"),
        _createEmojiWithNoKeyword("1f4a6"),
        _createEmoji("1f30a")
    ],
    _a["Activities" /* Activities */] = [
        _createEmoji("026bd"),
        _createEmoji("1f3c0"),
        _createEmoji("1f3c8"),
        _createEmoji("026be"),
        _createEmoji("1f3be"),
        _createEmoji("1f3b1"),
        _createEmoji("026f3"),
        _createEmoji("1f3bf"),
        _createEmoji("1f3c2"),
        _createEmoji("1f3a3"),
        _createEmoji("1f3ca"),
        _createEmoji("1f3c4"),
        _createEmoji("1f3c6"),
        _createEmoji("1f3bd"),
        _createEmoji("1f3ab"),
        _createEmoji("1f3ad"),
        _createEmoji("1f3a8"),
        _createEmoji("1f3aa"),
        _createEmoji("1f3a4"),
        _createEmoji("1f3a7"),
        _createEmoji("1f3bc"),
        _createEmoji("1f3b9"),
        _createEmoji("1f3b7"),
        _createEmoji("1f3ba"),
        _createEmoji("1f3b8"),
        _createEmoji("1f3bb"),
        _createEmoji("1f3ac"),
        _createEmoji("1f3ae"),
        _createEmoji("1f47e"),
        _createEmoji("1f3af"),
        _createEmoji("1f3b2"),
        _createEmoji("1f3b0"),
        _createEmoji("1f3b3")
    ],
    _a["Food" /* Food */] = [
        _createEmoji("1f34f"),
        _createEmoji("1f34e"),
        _createEmoji("1f34a"),
        _createEmoji("1f34c"),
        _createEmoji("1f349"),
        _createEmoji("1f347"),
        _createEmoji("1f353"),
        _createEmoji("1f348"),
        _createEmoji("1f352"),
        _createEmoji("1f351"),
        _createEmoji("1f34d"),
        _createEmoji("1f345"),
        _createEmoji("1f346"),
        _createEmoji("1f33d"),
        _createEmoji("1f360"),
        _createEmoji("1f35e"),
        _createEmoji("1f357"),
        _createEmoji("1f356"),
        _createEmoji("1f364"),
        _createEmoji("1f373"),
        _createEmoji("1f354"),
        _createEmoji("1f35f"),
        _createEmoji("1f355"),
        _createEmoji("1f35d"),
        _createEmoji("1f35c"),
        _createEmoji("1f372"),
        _createEmoji("1f365"),
        _createEmoji("1f363"),
        _createEmoji("1f371"),
        _createEmoji("1f35b"),
        _createEmoji("1f359"),
        _createEmoji("1f35a"),
        _createEmoji("1f358"),
        _createEmoji("1f362"),
        _createEmoji("1f361"),
        _createEmojiWithNoKeyword("1f367"),
        _createEmoji("1f368"),
        _createEmoji("1f366"),
        _createEmoji("1f370"),
        _createEmoji("1f36f"),
        _createEmoji("1f382"),
        _createEmoji("1f36e"),
        _createEmoji("1f36c"),
        _createEmoji("1f36d"),
        _createEmoji("1f36b"),
        _createEmoji("1f369"),
        _createEmoji("1f36a"),
        _createEmoji("1f37a"),
        _createEmoji("1f37b"),
        _createEmoji("1f377"),
        _createEmoji("1f378"),
        _createEmoji("1f379"),
        _createEmoji("1f376"),
        _createEmoji("1f375"),
        _createEmoji("02615"),
        _createEmoji("1f374")
    ],
    _a["Travel" /* Travel */] = [
        _createEmoji("1f697"),
        _createEmoji("1f695"),
        _createEmoji("1f687"),
        _createEmojiWithNoKeyword("1f699"),
        _createEmoji("1f68c"),
        _createEmoji("1f693"),
        _createEmoji("1f69a"),
        _createEmojiWithNoKeyword("1f691"),
        _createEmoji("1f692"),
        _createEmoji("1f6b2"),
        _createEmoji("1f6a8"),
        _createEmoji("1f683"),
        _createEmoji("1f684"),
        _createEmojiWithNoKeyword("1f685"),
        _createEmoji("1f689"),
        _createEmoji("02708"),
        _createEmoji("026f5"),
        _createEmojiWithNoKeyword("1f6a4"),
        _createEmoji("1f680"),
        _createEmoji("1f4ba"),
        _createEmoji("02693"),
        _createEmoji("1f6a7"),
        _createEmoji("026fd"),
        _createEmoji("1f68f"),
        _createEmoji("1f6a5"),
        _createEmoji("1f3c1"),
        _createEmoji("1f6a2"),
        _createEmoji("1f3a1"),
        _createEmoji("1f3a2"),
        _createEmoji("1f3a0"),
        _createEmoji("1f301"),
        _createEmojiWithNoKeyword("1f5fc"),
        _createEmoji("1f3ed"),
        _createEmoji("026f2"),
        _createEmojiWithNoKeyword("1f391"),
        _createEmojiWithNoKeyword("1f5fb"),
        _createEmojiWithNoKeyword("1f30b"),
        _createEmojiWithNoKeyword("1f5fe"),
        _createEmoji("1f305"),
        _createEmoji("1f304"),
        _createEmoji("1f307"),
        _createEmoji("1f306"),
        _createEmoji("1f303"),
        _createEmoji("1f309"),
        _createEmoji("1f30c"),
        _createEmoji("1f387"),
        _createEmoji("1f386"),
        _createEmoji("1f308"),
        _createEmoji("1f3f0"),
        _createEmojiWithNoKeyword("1f3ef"),
        _createEmoji("1f5fd"),
        _createEmoji("1f3e0"),
        _createEmoji("1f3e1"),
        _createEmoji("1f3e2"),
        _createEmoji("1f3ec"),
        _createEmoji("026fa"),
        _createEmojiWithNoKeyword("1f3e3"),
        _createEmojiWithNoKeyword("1f3e5"),
        _createEmoji("1f3e6"),
        _createEmoji("1f3e8"),
        _createEmoji("1f3ea"),
        _createEmoji("1f3eb"),
        _createEmojiWithNoKeyword("1f3e9"),
        _createEmoji("1f492"),
        _createEmoji("026ea"),
        _createEmoji("1f320")
    ],
    _a["Symbols" /* Symbols */] = [
        common3,
        _createEmoji("1f49b"),
        _createEmoji("1f49a"),
        _createEmoji("1f499"),
        _createEmoji("1f494"),
        _createEmoji("1f49c"),
        _createEmoji("1f495"),
        _createEmoji("1f493"),
        _createEmoji("1f49e"),
        _createEmoji("1f497"),
        _createEmoji("1f498"),
        _createEmoji("1f496"),
        _createEmoji("1f49d"),
        _createEmoji("1f49f"),
        _createEmojiWithNoKeyword("1f52f"),
        _createEmojiWithNoKeyword("026ce"),
        _createEmoji("02648"),
        _createEmoji("02649"),
        _createEmoji("0264a"),
        _createEmoji("0264b"),
        _createEmoji("0264c"),
        _createEmoji("0264d"),
        _createEmoji("0264e"),
        _createEmoji("0264f"),
        _createEmoji("02650"),
        _createEmoji("02651"),
        _createEmoji("02652"),
        _createEmoji("02653"),
        _createEmojiWithNoKeyword("1f194"),
        _createEmojiWithNoKeyword("1f4f4"),
        _createEmojiWithNoKeyword("1f4f3"),
        _createEmojiWithNoKeyword("1f19a"),
        _createEmojiWithNoKeyword("1f4ae"),
        _createEmojiWithNoKeyword("1f18e"),
        _createEmojiWithNoKeyword("1f191"),
        _createEmojiWithNoKeyword("1f198"),
        _createEmojiWithNoKeyword("026d4"),
        _createEmoji("1f4db"),
        _createEmoji("1f6ab"),
        _createEmojiWithNoKeyword("0274c"),
        _createEmojiWithNoKeyword("02b55"),
        _createEmojiWithNoKeyword("1f4a2"),
        _createEmoji("02668"),
        _createEmojiWithNoKeyword("1f51e"),
        _createEmojiWithNoKeyword("02757"),
        _createEmojiWithNoKeyword("02755"),
        _createEmojiWithNoKeyword("02753"),
        _createEmojiWithNoKeyword("02754"),
        _createEmojiWithNoKeyword("02049"),
        _createEmojiWithNoKeyword("1f4af"),
        _createEmoji("1f531"),
        _createEmojiWithNoKeyword("0303d"),
        _createEmoji("026a0"),
        _createEmojiWithNoKeyword("1f530"),
        _createEmojiWithNoKeyword("1f22f"),
        _createEmojiWithNoKeyword("1f4b9"),
        _createEmoji("02733"),
        _createEmojiWithNoKeyword("0274e"),
        _createEmojiWithNoKeyword("02705"),
        _createEmojiWithNoKeyword("1f4a0"),
        _createEmoji("1f300"),
        _createEmoji("1f3e7"),
        _createEmoji("0267f"),
        _createEmoji("1f6ad"),
        _createEmojiWithNoKeyword("1f6be"),
        _createEmoji("02734"),
        _createEmoji("1f17f"),
        _createEmoji("1f6b9"),
        _createEmoji("1f6ba"),
        _createEmojiWithNoKeyword("1f6bc"),
        _createEmoji("1f6bb"),
        _createEmoji("1f3a6"),
        _createEmoji("1f4f6"),
        _createEmojiWithNoKeyword("1f201"),
        _createEmojiWithNoKeyword("1f196"),
        _createEmojiWithNoKeyword("0267b"),
        _createEmojiWithNoKeyword("1f197"),
        _createEmojiWithNoKeyword("1f192"),
        _createEmoji("02747"),
        _createEmojiWithNoKeyword("1f195"),
        _createEmojiWithNoKeyword("1f193"),
        _createEmojiWithNoKeyword("1f51f"),
        _createEmojiWithNoKeyword("1f522"),
        _createEmojiWithNoKeyword("023ea"),
        _createEmojiWithNoKeyword("023e9"),
        _createEmojiWithNoKeyword("1f53c"),
        _createEmojiWithNoKeyword("1f53d"),
        _createEmojiWithNoKeyword("023eb"),
        _createEmojiWithNoKeyword("023ec"),
        _createEmojiWithNoKeyword("1f199"),
        _createEmojiWithNoKeyword("02139"),
        _createEmojiWithNoKeyword("1f524"),
        _createEmojiWithNoKeyword("1f521"),
        _createEmojiWithNoKeyword("1f520"),
        _createEmojiWithNoKeyword("1f523"),
        _createEmoji("1f3b5"),
        _createEmoji("1f3b6"),
        _createEmojiWithNoKeyword("03030"),
        _createEmojiWithNoKeyword("027bf"),
        _createEmojiWithNoKeyword("02714"),
        _createEmoji("1f503"),
        _createEmojiWithNoKeyword("02795"),
        _createEmojiWithNoKeyword("02796"),
        _createEmojiWithNoKeyword("02797"),
        _createEmojiWithNoKeyword("02716"),
        _createEmojiWithNoKeyword("027b0"),
        _createEmojiWithNoKeyword("1f4b2"),
        _createEmojiWithNoKeyword("1f4b1"),
        _createEmojiWithNoKeyword("1f51a"),
        _createEmojiWithNoKeyword("1f519"),
        _createEmojiWithNoKeyword("1f51b"),
        _createEmojiWithNoKeyword("1f51d"),
        _createEmojiWithNoKeyword("1f51c"),
        _createEmojiWithNoKeyword("02611"),
        _createEmojiWithNoKeyword("1f518"),
        _createEmojiWithNoKeyword("026ab"),
        _createEmojiWithNoKeyword("1f534"),
        _createEmojiWithNoKeyword("1f535"),
        _createEmojiWithNoKeyword("1f539"),
        _createEmojiWithNoKeyword("1f538"),
        _createEmojiWithNoKeyword("1f536"),
        _createEmojiWithNoKeyword("1f537"),
        _createEmojiWithNoKeyword("1f53a"),
        _createEmojiWithNoKeyword("1f53b"),
        _createEmojiWithNoKeyword("02b1b"),
        _createEmojiWithNoKeyword("02b1c"),
        _createEmojiWithNoKeyword("1f532"),
        _createEmojiWithNoKeyword("1f533"),
        _createEmojiWithNoKeyword("1f50a"),
        _createEmoji("1f4e3"),
        _createEmojiWithNoKeyword("1f4e2"),
        _createEmoji("1f514"),
        _createEmojiWithNoKeyword("1f004"),
        _createEmoji("1f0cf"),
        _createEmojiWithNoKeyword("1f3b4"),
        _createEmojiWithNoKeyword("1f4ac"),
        _createEmoji("1f550"),
        _createEmoji("1f551"),
        _createEmoji("1f552"),
        _createEmoji("1f553"),
        _createEmoji("1f554"),
        _createEmoji("1f555"),
        _createEmoji("1f556"),
        _createEmoji("1f557"),
        _createEmoji("1f558"),
        _createEmoji("1f559"),
        _createEmoji("1f55a"),
        _createEmoji("1f55b"),
        _createEmojiWithNoKeyword("1f236"),
        _createEmojiWithNoKeyword("1f250"),
        _createEmojiWithNoKeyword("1f239"),
        _createEmojiWithNoKeyword("1f21a"),
        _createEmojiWithNoKeyword("1f232"),
        _createEmojiWithNoKeyword("1f251"),
        _createEmojiWithNoKeyword("1f234"),
        _createEmojiWithNoKeyword("1f233"),
        _createEmojiWithNoKeyword("1f23a"),
        _createEmojiWithNoKeyword("1f235")
    ],
    _a["Objects" /* Objects */] = [
        _createEmojiWithNoKeyword("0231a"),
        _createEmoji("1f4f1"),
        _createEmojiWithNoKeyword("1f4f2"),
        _createEmoji("1f4bb"),
        _createEmojiWithNoKeyword("1f4bd"),
        _createEmoji("1f4be"),
        _createEmoji("1f4bf"),
        _createEmoji("1f4c0"),
        _createEmoji("1f4fc"),
        _createEmoji("1f4f7"),
        _createEmoji("1f4f9"),
        _createEmoji("1f3a5"),
        _createEmoji("1f4de"),
        _createEmojiWithNoKeyword("0260e"),
        _createEmoji("1f4df"),
        _createEmoji("1f4e0"),
        _createEmoji("1f4fa"),
        _createEmoji("1f4fb"),
        _createEmojiWithNoKeyword("023f0"),
        _createEmojiWithNoKeyword("0231b"),
        _createEmojiWithNoKeyword("023f3"),
        _createEmoji("1f4e1"),
        _createEmoji("1f50b"),
        _createEmoji("1f50c"),
        _createEmoji("1f4a1"),
        _createEmoji("1f526"),
        _createEmojiWithNoKeyword("1f4b8"),
        _createEmoji("1f4b5"),
        _createEmoji("1f4b4"),
        _createEmoji("1f4b0"),
        _createEmoji("1f4b3"),
        _createEmoji("1f48e"),
        _createEmoji("1f527"),
        _createEmoji("1f528"),
        _createEmoji("1f529"),
        _createEmojiWithNoKeyword("1f52b"),
        _createEmoji("1f4a3"),
        _createEmoji("1f52a"),
        _createEmoji("1f6ac"),
        _createEmoji("1f52e"),
        _createEmoji("1f488"),
        _createEmoji("1f48a"),
        _createEmoji("1f489"),
        _createEmoji("1f516"),
        _createEmoji("1f6bd"),
        _createEmoji("1f6c0"),
        _createEmoji("1f511"),
        _createEmoji("1f6aa"),
        _createEmojiWithNoKeyword("1f5ff"),
        _createEmoji("1f388"),
        _createEmojiWithNoKeyword("1f38f"),
        _createEmoji("1f380"),
        _createEmoji("1f381"),
        _createEmoji("1f38a"),
        _createEmoji("1f389"),
        _createEmojiWithNoKeyword("1f38e"),
        _createEmoji("1f390"),
        _createEmojiWithNoKeyword("1f38c"),
        _createEmojiWithNoKeyword("1f3ee"),
        _createEmoji("02709"),
        _createEmoji("1f4e9"),
        _createEmoji("1f4e8"),
        _createEmoji("1f48c"),
        _createEmoji("1f4e7"),
        _createEmoji("1f4ee"),
        _createEmoji("1f4ea"),
        _createEmoji("1f4eb"),
        _createEmoji("1f4e6"),
        _createEmojiWithNoKeyword("1f4e5"),
        _createEmojiWithNoKeyword("1f4e4"),
        _createEmojiWithNoKeyword("1f4dc"),
        _createEmojiWithNoKeyword("1f4c3"),
        _createEmojiWithNoKeyword("1f4d1"),
        _createEmoji("1f4ca"),
        _createEmoji("1f4c8"),
        _createEmoji("1f4c9"),
        _createEmojiWithNoKeyword("1f4c4"),
        _createEmoji("1f4c5"),
        _createEmojiWithNoKeyword("1f4c6"),
        _createEmojiWithNoKeyword("1f4c7"),
        _createEmoji("1f4cb"),
        _createEmoji("1f4c1"),
        _createEmojiWithNoKeyword("1f4c2"),
        _createEmoji("1f4f0"),
        _createEmoji("1f4d3"),
        _createEmojiWithNoKeyword("1f4d5"),
        _createEmojiWithNoKeyword("1f4d7"),
        _createEmojiWithNoKeyword("1f4d8"),
        _createEmojiWithNoKeyword("1f4d9"),
        _createEmojiWithNoKeyword("1f4d4"),
        _createEmoji("1f4d2"),
        _createEmoji("1f4da"),
        _createEmojiWithNoKeyword("1f4d6"),
        _createEmojiWithNoKeyword("1f517"),
        _createEmoji("1f4ce"),
        _createEmoji("02702"),
        _createEmojiWithNoKeyword("1f4d0"),
        _createEmoji("1f4cf"),
        _createEmoji("1f4cc"),
        _createEmoji("1f4cd"),
        _createEmojiWithNoKeyword("1f6a9"),
        _createEmoji("1f510"),
        _createEmoji("1f512"),
        _createEmoji("1f513"),
        _createEmoji("1f50f"),
        _createEmojiWithNoKeyword("02712"),
        _createEmoji("1f4dd"),
        _createEmoji("0270f"),
        _createEmoji("1f50d"),
        _createEmojiWithNoKeyword("1f50e")
    ],
    _a);
exports.default = EmojiList;
exports.EmojiFabricIconCharacterMap = (_b = {},
    _b["Activities" /* Activities */] = "Soccer",
    _b["Food" /* Food */] = "EatDrink",
    _b["Nature" /* Nature */] = "FangBody",
    _b["Objects" /* Objects */] = "Lightbulb",
    _b["People" /* People */] = "Emoji2",
    _b["Symbols" /* Symbols */] = "Heart",
    _b["Travel" /* Travel */] = "Car",
    _b);
function forEachEmojiFamily(callback) {
    var families = Object.keys(EmojiList);
    for (var _i = 0, families_1 = families; _i < families_1.length; _i++) {
        var family = families_1[_i];
        if (!callback(EmojiList[family], family)) {
            break;
        }
    }
}
exports.forEachEmojiFamily = forEachEmojiFamily;
function forEachEmoji(callback) {
    forEachEmojiFamily(function (emojis) {
        for (var _i = 0, emojis_1 = emojis; _i < emojis_1.length; _i++) {
            var emoji = emojis_1[_i];
            if (!callback(emoji)) {
                return false;
            }
        }
        return true;
    });
}
exports.forEachEmoji = forEachEmoji;
// get emoji code point from an emoji key
function _getEmojiCodePoint(key) {
    var unicode = parseInt(key, 16);
    if (isNaN(unicode)) {
        return null;
    }
    // All emojis have codepoints between the following ranges:
    // 0x1F7000 - 0x1F700 -> has surrogate pairs
    // 0x00023 - 0x04000 -> does not have surrogate pairs
    var surrogatePairs;
    if (unicode >= 0x1f000 && unicode <= 0x1f700) {
        var hi = Math.floor((unicode - 0x10000) / 0x400) + 0xd800;
        var lo = ((unicode - 0x10000) % 0x400) + 0xdc00;
        surrogatePairs = [hi, lo];
    }
    else if (unicode >= 0x00023 && unicode <= 0x04000) {
        surrogatePairs = [unicode];
    }
    return String.fromCharCode.apply(String, surrogatePairs);
}
function _createEmoji(key, shortcut) {
    return { key: key, description: "emjD" + key, keywords: "emjK" + key, shortcut: shortcut, codePoint: _getEmojiCodePoint(key) };
}
function _createEmojiWithNoKeyword(key) {
    return { key: key, description: "emjD" + key, codePoint: _getEmojiCodePoint(key) };
}
//# sourceMappingURL=emojiList.js.map